/*
 * Project: bellcloud
 * File: packages/types/device/transfer_mode.ts
 * Author: SWAN
 * Created: 2025-07-21 18:10:58
 * Description:
 */

export enum TransferMode {
  NORMAL = 0,
  BURST = 1,
}
